import './breadcrumb.scss';

export default () => {

};
